import React, {useEffect, useState} from "react"
import {Outlet, useNavigate} from "react-router-dom";

import LanguageSelector from "./LanguageMenu";

import AppBar from "@mui/material/AppBar";
import { styled } from '@mui/material/styles';
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import AccountCircle from '@mui/icons-material/AccountCircle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {useTranslation} from "react-i18next";


// If you use the public folder
const backgroundImage = '/img/gray_sky.jpg';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'auto',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'center top',
}));

const Logo = styled('img')(({ maxHeight }) => ({
    width: 'auto',
    height: 163,
    maxHeight: maxHeight,
    transition: 'max-height 0.1s linear',
}));

const PublicAppBar = ({scrolled}) => {
    const {t} = useTranslation(['layouts'])
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    // Logo scale changes when scrolled
    //const maxHeight = scrolled ? 100 : 163;

    return (
        <StyledAppBar>
            <Toolbar disableGutters>
                <Container
                    maxWidth="xxl"
                    sx={{ display: 'flex', justifyContent: 'space-between'}}
                >
                    {/* Left: Logo */}
                    <a href="https://aineva.it" target="_blank">
                        <Logo src="/img/aineva_logo_300_163.png" alt="Logo" maxHeight={163} />
                    </a>

                    {!isMobile && (
                        <Box sx={{ alignSelf: 'center', padding: '0 32px'}}>
                            <Typography
                                sx={{
                                    color: '#0095d5',
                                    fontSize: 23, //scrolled ? 16 : 23,
                                    fontFamily: `"Open Sans", HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif`,
                                    textAlign: 'center',
                                    fontWeight: 500,
                                    whiteSpace: 'pre-line',
                                    transition: 'font-size 0.1s linear',
                                }}
                            >
                                { t("public.appBarTitle") }
                            </Typography>
                        </Box>
                    )}

                    {/* Right: LanguageSelector + User Icon */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, alignSelf: 'end'}}>
                        <LanguageSelector />
                        <IconButton color="inherit" onClick={() => navigate('/dashboard')}>
                            <AccountCircle fontSize="small" />
                        </IconButton>
                    </Box>
                </Container>
            </Toolbar>
        </StyledAppBar>
    );
};


const PublicLayout = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    //const appBarHeight = scrolled ? 100 : 163 + 16; // 16px for padding, 163px for logo height

    return <>
        <PublicAppBar scrolled={scrolled}/>
        <Box
            component="main"
            sx={{
                pt: `173px`,
                pb: 32,
                minHeight: '100vh',
            }}
        >
            <Outlet/>
        </Box>
    </>
}



export default PublicLayout